export default __webpack_public_path__ + "static/media/magic_link.0ad9a680.svg";